export * from './agencies.service';
import { AgenciesService } from './agencies.service';
export * from './booking.service';
import { BookingService } from './booking.service';
export * from './customers.service';
import { CustomersService } from './customers.service';
export * from './debug.service';
import { DebugService } from './debug.service';
export * from './report.service';
import { ReportService } from './report.service';
export * from './settings.service';
import { SettingsService } from './settings.service';
export * from './users.service';
import { UsersService } from './users.service';
export * from './vehicles.service';
import { VehiclesService } from './vehicles.service';
import { InvoiceService } from './invoice.service';
export * from './invoice.service';
export const APIS = [InvoiceService,AgenciesService, BookingService, CustomersService, DebugService, ReportService, SettingsService, UsersService, VehiclesService];
